module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "align-items": "center",
      "height": "100vh",
      "margin-top": "5%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "gap": "20px",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "src": "/static/images/lined_check.svg"
    }
  }), _vm._v(" "), _c('div', [_c('center', {
    staticStyle: {
      "font-weight": "800",
      "font-size": "30px"
    }
  }, [_vm._v("\n          Check Your Email\n        ")]), _vm._v(" "), _c('center', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("\n          Your account has been created!\n        ")])], 1)])]), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "px-3 mt-4 login-button",
    staticStyle: {
      "width": "300px",
      "padding": "15px 5px",
      "border-radius": "25px",
      "color": "white",
      "font-size": "18px",
      "height": "50px"
    },
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": _vm.sendConfirmEmail
    }
  }, [_vm._v("\n      Resend email\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "width": "169px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93f75c9a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/checkEmail.vue
// module id = 1814
// module chunks = 180